export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  brandStory: string[];
  mission: string;
  vision: string;
  values: { title: string; description: string; icon: string }[];
  milestones: { year: string; title: string; description: string }[];
  testimonials: { name: string; avatarSeq: string; content: string; role: string }[];
  contact: {
    email: string;
    wechat: string;
    qq: string;
    address: string;
    workingHours: string;
  };
}

export const aboutInfo: AboutInfo = {
  brandName: 'ASMR基佬中心',
  brandIntro: 'ASMR基佬中心成立于2020年，是国内领先的ASMR内容聚合社区平台。我们致力于为ASMR爱好者提供最全面、最优质的ASMR内容资源，打造一个温馨、包容、专业的ASMR社区。从助眠放松、耳语陪伴到触发音效、角色扮演，我们涵盖了ASMR的所有主流类型，满足不同用户的个性化需求。',
  brandStory: [
    '2020年初，一群热爱ASMR的年轻人在网上相遇。他们发现，尽管ASMR在国内已经有了不少受众，但却缺少一个真正专注于ASMR内容聚合和社区交流的平台。于是，ASMR基佬中心应运而生。',
    '从最初的几个人手动搜集整理ASMR资源，到如今拥有数万注册用户和近千名活跃创作者，ASMR基佬中心已经发展成为国内最具影响力的ASMR内容聚合平台之一。',
    '我们始终相信，ASMR不仅是一种娱乐形式，更是一种可以帮助人们改善生活质量的有益工具。无论是帮助失眠者安然入睡，还是为焦虑的心灵提供片刻宁静，ASMR都有着不可替代的价值。',
  ],
  mission: '让每一个需要放松的人，都能找到属于自己的声音港湾。',
  vision: '成为全球最受信赖的华语ASMR内容聚合与社区平台，推动ASMR文化在中国的健康发展。',
  values: [
    { title: '内容为王', description: '坚持严格的内容筛选标准，只收录高品质的ASMR内容，确保每位用户都能获得最佳的聆听体验。', icon: 'ri-star-line' },
    { title: '用户至上', description: '以用户需求为导向，持续优化平台体验，让寻找和享受ASMR内容变得简单而愉悦。', icon: 'ri-heart-line' },
    { title: '社区共建', description: '鼓励用户参与内容推荐和社区建设，让ASMR基佬中心成为一个真正属于ASMR爱好者的家园。', icon: 'ri-group-line' },
    { title: '开放包容', description: '尊重ASMR的多样性，包容不同流派、不同风格的创作者和内容，让每一种声音都有被听见的机会。', icon: 'ri-global-line' },
  ],
  milestones: [
    { year: '2020年3月', title: '平台创立', description: 'ASMR基佬中心正式成立，首批收录1000+ASMR内容资源。' },
    { year: '2021年1月', title: '用户破万', description: '注册用户突破10000人，成为国内增长最快的ASMR社区之一。' },
    { year: '2021年9月', title: '创作者计划', description: '启动ASMR创作者扶持计划，帮助优秀创作者获得更多曝光。' },
    { year: '2022年6月', title: '内容升级', description: '全面升级内容分类体系，新增角色扮演、美食咀嚼等热门分类。' },
    { year: '2023年3月', title: '用户破五万', description: '注册用户突破50000人，内容总量超过10000+。' },
    { year: '2024年1月', title: '品牌升级', description: '完成品牌视觉升级，推出全新Logo和网站界面。' },
    { year: '2025年至今', title: '持续成长', description: '持续优化用户体验，扩展内容品类，服务更多ASMR爱好者。' },
  ],
  testimonials: [
    { name: '失眠的小王', avatarSeq: 'avatar-01', content: '自从发现了ASMR基佬中心，我的失眠问题得到了很大改善。每天晚上听着助眠音频入睡，已经成为了我雷打不动的习惯。感谢这个平台！', role: '平台用户 - 使用2年' },
    { name: '声音猎人', avatarSeq: 'avatar-02', content: '作为一名ASMR创作者，非常感谢基佬中心提供的展示平台。这里的社区氛围非常友好，让我找到了志同道合的声音伙伴。', role: 'ASMR创作者' },
    { name: '焦虑的小李', avatarSeq: 'avatar-03', content: '工作压力大的时候，我就会打开基佬中心，听一段触发音或者白噪音。真的很神奇，几分钟就能让我的心情平复下来。', role: '平台用户 - 使用1年' },
    { name: '夜猫子小张', avatarSeq: 'avatar-04', content: '以前经常熬夜到凌晨三四点，现在每晚十点准时打开基佬中心，听一段耳语ASMR，不到半小时就能睡着了。真的改变了我的生活！', role: '平台用户 - 使用6个月' },
  ],
  contact: {
    email: 'hello@asmr-geek-center.com',
    wechat: 'ASMRGeekCenter',
    qq: '1234567890',
    address: '中国广东省深圳市南山区科技园路88号',
    workingHours: '周一至周五 09:00 - 18:00',
  },
};

export const faqList = [
  {
    question: '什么是ASMR？',
    answer: 'ASMR（Autonomous Sensory Meridian Response）即"自主感觉经络反应"，是一种由特定听觉或视觉刺激引发的愉悦感和放松感。常见的感觉包括头皮酥麻、脊椎发凉等，被爱好者们称为"颅内高潮"或"大脑按摩"。',
  },
  {
    question: 'ASMR基佬中心是免费的吗？',
    answer: '是的，ASMR基佬中心的所有内容目前都是免费开放给所有用户访问的。我们致力于让更多人能够轻松享受到优质的ASMR内容。未来如果推出付费功能，会提前通知所有用户。',
  },
  {
    question: '如何开始我的ASMR体验？',
    answer: '我们建议新手从以下几个方面开始：1）准备一副舒适的耳机；2）选择安静的环境；3）从"耳语陪伴"或"助眠放松"分类开始尝试；4）保持耐心，不是每个人都能立刻感受到ASMR；5）浏览不同分类，找到最适合你的声音类型。',
  },
  {
    question: 'ASMR对失眠真的有效吗？',
    answer: '研究表明，ASMR对于改善睡眠质量有显著效果。通过降低心率、减少压力激素的分泌，ASMR能够帮助大脑从活跃状态过渡到放松状态。在ASMR基佬中心的用户调查中，超过78%的失眠用户表示，定期聆听ASMR后睡眠质量得到了明显改善。',
  },
  {
    question: '平台上有哪些ASMR分类？',
    answer: '我们目前涵盖了六大主流ASMR分类：助眠放松、耳语陪伴、触发音效、角色扮演、美食咀嚼和环境白噪音。每个分类下都有大量精心挑选的优质内容，未来还会根据用户需求不断增加新的分类。',
  },
  {
    question: '所有音频都适合在睡前听吗？',
    answer: '不是所有ASMR内容都适合睡前聆听。助眠放松和环境白噪音分类下的内容最适合睡前使用，而触发音效和角色扮演等分类则更适合白天的放松时刻。我们为每个内容标注了推荐聆听场景，帮助用户做出最适合的选择。',
  },
  {
    question: '如何联系ASMR基佬中心？',
    answer: '您可以通过以下方式联系我们：发送邮件至hello@asmr-geek-center.com，或添加我们的微信ASMRGeekCenter。我们的工作时间是周一至周五 09:00至18:00。我们也欢迎创作者通过以上渠道与我们联系，交流合作事宜。',
  },
  {
    question: '我可以成为ASMR创作者吗？',
    answer: '当然可以！我们非常欢迎优秀的ASMR创作者加入我们的平台。请将您的作品样本和简介发送至hello@asmr-geek-center.com，我们的内容团队会认真审阅每一份投稿，并在7个工作日内给您回复。',
  },
];